export { default as VendorsV2Mspa } from "./VendorsV2Mspa";
